import { useEffect, useRef, useState } from "react";

/**
 * @description To handle the timer for and @return time with `Time Action`
 *
 * @returns {time: number, pauseTimer: () => void, resumeTimer: () => void, stopTimer: () => void}
 *
 * @author [Rajkumar Rathod]
 */
export const useTimer = (prefillTime: number = 0) => {
  const [time, setTime] = useState<number>(prefillTime);
  const interval = useRef<ReturnType<typeof setInterval> | null>(null);
  const [stopTime, setStopTime] = useState<number>(0);
  const [status, setStatus] = useState<"running" | "paused" | "stopped">(
    "stopped"
  );

  const resetCurrentInterval = () => {
    if (interval.current) {
      clearInterval(interval.current);
      interval.current = null;
    }
  };

  useEffect(() => {
    if (status === "running") {
      interval.current = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    } else {
      resetCurrentInterval();
    }

    return resetCurrentInterval;
  }, [status]);

  const pauseTimer = () => {
    setStatus("paused");
  };

  const resumeTimer = () => {
    setStatus("running");
  };

  const stopTimer = () => {
    setStatus("stopped");
    setTime(0);
    setStopTime(time);
  };

  const startTimer = () => {
    setTime(0);
    setStatus("running");
  };

  return {
    time: time || stopTime,
    pauseTimer,
    resumeTimer,
    stopTimer,
    startTimer,
  };
};
